import React from "react";
var __jsx = React.createElement;
import { useEffect, useRef } from "react";
import { useTranslation } from "@i18n";
import { CDN_LINK } from "@globalConfig";
import FlowButton from "@/pages/sell-my-car/components/FlowButton";
import Layout from "@/_LayoutsRelated/layout/Layout";
import useHelpers from "@hooks/useHelpers";
import { useParams } from "react-router-dom";
import useIsWebView from "@hooks/useIsWebview";
import useWebview from "@hooks/useWebview";
import { trackEvents } from "@/common/events/events";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
var PaymentFailedScreen = function PaymentFailedScreen() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var params = useParams();
  var request_id = params === null || params === void 0 ? void 0 : params.request_id;
  var isWebView = useIsWebView();
  var webview = useWebview();
  var hasTrackedEvent = useRef(false);
  var handleRetryPayment = function handleRetryPayment() {
    navigateTo("/site/sell-my-car?request_id=" + request_id);
  };
  useEffect(function () {
    if (isWebView) {
      webview.openScreen("payment_failed", {
        request_id: request_id
      }).then();
    }
  }, [isWebView]);

  // Track payment failed event
  useEffect(function () {
    if (request_id && !hasTrackedEvent.current) {
      hasTrackedEvent.current = true;
      trackEvents("sell_car_appointment_book", {
        request_id: request_id,
        payment_status: "failed",
        platform: getPlatformInfo()
      });
    }
  }, [request_id]);
  if (!request_id) {
    navigateTo("/?ref=request_id_not_found");
  }
  return /*#__PURE__*/React.createElement(Layout, {
    hideDownloadBanner: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 md:bg-blue-alice md:min-h-[285px]"
  }), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-payment-failed-screen",
    className: "p-4 flex flex-col gap-8 md:p-6 mt-[185px] md:max-w-[600px] md:mx-auto md:border md:border-solid md:border-gray-echo md:bg-white md:rounded-2xl md:mt-[-200px] md:min-h-[470px] md:justify-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col items-center justify-center gap-4 mx-auto"
  }, /*#__PURE__*/React.createElement("img", {
    id: "sell-car-payment-failed-icon",
    src: CDN_LINK + "/assets/images/exclamation-mark.svg",
    alt: "Payment Failed",
    className: "w-20 h-20 md:w-20 md:h-20"
  }), /*#__PURE__*/React.createElement("h2", {
    id: "sell-car-payment-failed-heading",
    className: "text-primary-new text-xl font-bold text-center md:text-2xl"
  }, tShort("sell_trade_v2/payment_failed_heading", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("p", {
    id: "sell-car-payment-failed-message",
    className: "text-black-primary text-base text-center"
  }, tShort("sell_trade_v2/payment_failed_message", {
    ns: "web_sell_trade"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col px-4 gap-2 pb-6 w-full  md:relative md:!mt-8 md:max-w-[340px] md:mx-auto md:gap-5"
  }, /*#__PURE__*/React.createElement(FlowButton, {
    id: "sell-car-payment-failed-retry-btn",
    onClick: handleRetryPayment
  }, tShort("sell_trade_v2/retry_payment", {
    ns: "web_sell_trade"
  })))));
};
export default PaymentFailedScreen;